
import { Vue, Options } from "vue-class-component";

@Options({})
export default class ArrowUpMedium extends Vue {}
